import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [{
    template: '<wt-performance-heat-map-state></wt-performance-heat-map-state>',
    name: 'performanceHeatMap',
    url: '/performanceHeatMap',
    data: {
        visible: false,
        displayName: 'Online performance heat map'
    }
}];

export default states;